<template>
    <FKBreadCrumb :page="$t('page.content_categories')" :title="$t('page.content_library')"/>
    <ContentCategoriesList/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FKBreadCrumb from '@/components/Widgets/BreadCrumb/FKBreadCrumb.vue';
import ContentCategoriesList from "@/components/FK/Contents/Categories/ContentCategoriesList.vue";

export default defineComponent({
    name: 'ContentCategoriesPage',
    components: {
        FKBreadCrumb,
        ContentCategoriesList
    }
})
</script>